module.exports = __webpack_public_path__ + "static/img/ctjieduimg6.93a1df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctjieduimg6.png
// module id = 9lfN
// module chunks = 5